<div class="d-flex flex-column content">

  <div class="p-2 align-self-center">
    <h3>{{ 'ac.description' | translate}}</h3>
  </div>

  <div class="container">
    <div class="row shadow p-3 mb-3 bg-white ">
      <div class="col-3 p-0 align-self-center">
        @if (consentAccepted) {
          <div>
            <img class="auto-cursor" src="../../../assets/img/icon/green_icon.png">
          </div>
        } @else {
          <img class="auto-cursor" src="../../../assets/img/icon/grey_icon.png">
        }
      </div>
      <div class="col-8 p-0 align-self-center">
        <label class="red-24 font-weight-bold">{{ 'ac.consent' | translate}}</label>
      </div>
      <div class="col p-0 align-self-center">
        @if (consentAccepted) {
          <div>
            <a (click)="onConsentStart()">
              <img src="../../../assets/img/icon/arrow_right_22x10.svg">
            </a>
          </div>
        } @else {
          <img class="auto-cursor" src="../../../assets/img/icon/arrow_right_22x10.svg">
        }
      </div>
    </div>
  </div>
</div>
